import styled, { css } from 'styled-components';
import { Dropdown, Menu } from 'antd';

interface Container {
	theme: any,
	width?: number,
	opacity?: number,
	isDisabled?: boolean,
}

interface IDropdown {
	theme: any,
}

export const Title = styled.div<{highlight:boolean, titleFontWeight:number|string}>`
	position: relative;
	width: 100%;
	font-size: 12px;
	font-weight: ${(props) => props.titleFontWeight || 600};	
	margin-bottom: 7px;
	
	${(props) => props.highlight && css`
		color: ${props.theme.colors.red};
		animation: blink 1s linear 5;
		
		/* Safari 4.0 - 8.0 */
		@-webkit-keyframes blink {
			50% {
				opacity: 0;
			}
		}
		
		/* Standard syntax */
		@keyframes blink {
			50% {
				opacity: 0;
			}
		}
	`}

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		margin-bottom: 10px;
	}
`;

export const Image = styled.img`
  width: 20px;
  height: 20px;
  object-fit: cover;
  border-radius: 50%;  
  margin-right:7px;

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    margin-bottom: 4px;
  };
`;



export const StyledDropdown = styled(Dropdown)`
	cursor: pointer;
	padding: 5px 10px;
	border: ${(props: IDropdown) => `2px solid ${props.theme.colors.borderColor}`};
	background-color:${(props) => props.theme.colors.white};
	i {
		margin-left: 10px;
	}

	& .svg-wrapper {
		display: inline;

		svg {
			transition: transform 0.1s !important;
			path {
				fill: ${(props: IDropdown) => props.theme.colors.backgroundBlack}
			}
		}
	};
	
	&.ant-dropdown-open {
		svg {
			transform: translate(0,-50%) rotateZ(90deg) !important;	
		}
	}
`;

export const StyledMenu = styled(Menu)`
	border-radius: 5px;
	box-shadow: -5px 5px 10px rgba(0, 0, 0, 0.15);
	
	padding: 10px 10px;
	
	overflow-y: auto;
	/* min-width: 100px; */
	max-height: 400px;
`;

export const SelectedOption = styled.div`
	position: relative;
	width: 100%;
	display:flex;
	align-items: center;

	&& span{
		line-height:18px
	}

	&& svg {
		position: absolute;
		width: 5px;
		top: 50%;
		right: 10px;
		transition: transform 3s;
		transform: translate(0,-50%) rotateZ(270deg);
		vertical-align: middle;
		color: ${({ theme }) => theme.colors.fallow};
	}
`;

export const StyledMenuItem = styled(Menu.Item)`
	position: relative;
	display: flex;
    align-items: center;
	${({ isSelected }: { isSelected: boolean }) => isSelected
		&& css`
			color: ${({ theme }) => theme.colors.fallow};
			font-weight: bold;
				
			&::after {
				position: absolute;
				width: 10px;
				height: 10px;
				border-radius: 50%;
	
				background: ${({ theme }) => theme.colors.fallow};
				
				right: -2px;
				top: 0;
				bottom: 0;
				margin: auto;
				
				content: '';
			}
		`};
	
	&:hover {
		background-color: ${({ theme }) => theme.colors.borderColor};
	}
`;
// width: ${(props: Container) => props.width || 150}px;
export const DropdownContainer = styled.div<{width: number, opacity:number, isDisabled:boolean}>`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	
	width: 100%;	
	
	opacity: ${(props: Container) => props.opacity || 1};

	font-weight: 500;

	
	font-style: normal;
	font-size: 12px;
	
	${(props: Container) => props.isDisabled && css`
		color: ${props.theme.colors.silver};

		${StyledDropdown}, svg {
			cursor: not-allowed;
			color: ${props.theme.colors.silver} !important;
		}

		${StyledDropdown} {
			border: 2px solid white;
			border: 2px solid transparent;
		}
	`}

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		
	}
`;

export const PurityDropdownContainer = styled.div`	
	font-weight: 500;
	text-align: center;
	font-style: normal;
	font-size: 12px;	
	display:flex
`;

export const PurityDropdownItem = styled.div<{isLastItem:boolean,isCheck:boolean}>`
	width: 100%;
	height:34px;
	line-height: 34px;
	margin-right:${(props) => props.isLastItem ? '0' : '5px'};
	background-color:${(props)=> props.isCheck ? '#DBDAD8' :  props.theme.colors.white};
	cursor:pointer
`;

// ${(props: Container) => props.isDisabled && css`
// 		color: ${props.theme.colors.silver};

// 		${StyledDropdown}, svg {
// 			cursor: not-allowed;
// 			color: ${props.theme.colors.silver} !important;
// 		}

// 		${StyledDropdown} {
// 			border: 2px solid white;
// 			border: 2px solid transparent;
// 		}
// 	`}